import { useContext } from "react";
import { Navigate } from "react-router-dom";
import { AppContext } from "../App";
import { AuditTrailTable } from "../components/AuditTrail";
import { Badge, Row, Col } from "antd";
import { PageHeader } from "@ant-design/pro-layout";
import { Content } from "antd/es/layout/layout";

export const AuditTrailPage: React.FC = () => {
    const [context] = useContext(AppContext);

    if (!context.user?.admin) {
        return <Navigate to="/dashboard" />;
    }

    return (
        <Badge.Ribbon text="Admin">
            <PageHeader className="site-page-header-responsive" />
            <Content>
                <Row>
                    <Col span={24}>
                        <AuditTrailTable />
                    </Col>
                </Row>
            </Content>
        </Badge.Ribbon>
    );
}

export default AuditTrailPage;
